const barcodePrefix = '+';
const barcodeSuffix = '=';
const hotkeyPrefix = 'Ctrl ';

export const convertPresetToBarcodeProperties = (presets) => {
  return presets
    .filter((p) => p.hotKey)
    .map((preset) => ({
      hotkey: `${hotkeyPrefix}${preset.hotKey.toString()}`,
      barcodeContent: `${barcodePrefix}${preset.hotKey.toString().charCodeAt(0)}${barcodeSuffix}`,
      ...preset,
    }));
};
